import Dashboard from './Dashboard';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { DashboardList } from './DashboardList';

export default {
  list: DashboardList,
  icon: DashboardIcon,
};
